export * from 'vue-i18n'
import { PlatformKey } from 'platform-config'
import { merge } from 'utils'

import { createI18n } from 'vue-i18n'
import eightEightLanguage from './88-lang.json'
import cloudComputingPowerDefaultLanguage from './cloud-computing-power-default-lang.json'
import defaultLanguage from './default-lang.json'

export const DefaultLanguage = {
  ...cloudComputingPowerDefaultLanguage,
  ...defaultLanguage,
}
const mergedLanguage = merge(DefaultLanguage, PlatformKey === '88' ? eightEightLanguage : {})

export const i18n = createI18n({
  locale: 'zh_CN',
  messages: {
    zh_CN: mergedLanguage,
  } as Record<string, Record<string, string>>,
  silentTranslationWarn: true, // 关闭翻译缺失警告
  silentFallbackWarn: true, // 关闭回退警告
})
